export const DetailsTableColumnAlign = {
  left: 'left',
  right: 'right',
} as const

export type DetailsTableColumnAlign =
  (typeof DetailsTableColumnAlign)[keyof typeof DetailsTableColumnAlign]

export type DetailsTableColumn = {
  key: string
  labelKey?: string
  align?: DetailsTableColumnAlign
  modifier?: string
}

export type DetailsTableRow = Record<string, string | number | boolean | undefined>

export const DetailsTableFooterRowTone = {
  secondary: 'secondary',
  primary: 'primary',
  highlight: 'highlight',
} as const

export type DetailsTableFooterRowTone =
  (typeof DetailsTableFooterRowTone)[keyof typeof DetailsTableFooterRowTone]

export const DetailsTableFooterRowEmphasis = {
  medium: 'medium',
  regular: 'regular',
} as const

export type DetailsTableFooterRowEmphasis =
  (typeof DetailsTableFooterRowEmphasis)[keyof typeof DetailsTableFooterRowEmphasis]

export type DetailsTableFooterRow = {
  labelKey: string
  value: string | number
  tone?: DetailsTableFooterRowTone
  emphasis?: DetailsTableFooterRowEmphasis
}

export type DetailsTableFooter = {
  summaryRows?: DetailsTableFooterRow[]
  expandableRows?: DetailsTableFooterRow[]
}

export type DetailsTableCellSlotProps = {
  value: DetailsTableRow[string]
  row: DetailsTableRow
  column: DetailsTableColumn
}
